import "./Styles/Footer.scss";
const Footer = () => {
  return (
    <footer className="text-muted fixed-bottom">
      &copy; React CRUD App by HKD
    </footer>
  );
};

export default Footer;
